import { useContext, useEffect, useLayoutEffect, useMemo, useRef, useState, useTransition } from 'react';
import style from './Config.module.css';
import classNames from 'classnames/bind';
import { Alert, Button, Toast } from '../../../../../components';
import { RefreshIcon, RestoreIcon, SquareIcon } from '../../../../../components/Icons/Icons';
import { getRoiList, listAiTranslate } from '../../../../../utils';
import axiosClient from '../../../../../services/axiosClient';
import { ReactPlayer } from '../../../../../components';
import { SettingAIContext } from '../../../../../contexts';
import { useTranslation } from 'react-i18next';
import iconSrc from "../../../../../assets/images/position_car_park.svg";
const cx = classNames.bind(style);

function ConfigPositionCarPark() {
    const { nameService, cameraCode, codeService, permissionChange, onClose, setIsLoading, showReload, setShowReload } = useContext(SettingAIContext)
    const canvasRef = useRef(null);
    const [canvas, setCanvas] = useState(null);
    const [roiListCode, setRoiListCode] = useState();
    const [draw, setDraw] = useState(false);
    const [alert, setAlert] = useState(false);
    const [reGetData, setReGetData] = useState(false);
    const [path, setPath] = useState();
    let width = 491;
    let height = 279;
    const [listPosition, setListPosition] = useState([]);
    const { t } = useTranslation();
    const [pointEnter, setPointEnter] = useState(null);

    const getConfigRoi = async () => {
        try {
            const res = await axiosClient.get(`aiConfigRoiList/get-list-ai-config-roi-list/?camera_code=${cameraCode}&ai_service_code=${codeService}`);
            let data = {};
            res.forEach(item => {
                data = item;
            })
            if (res && res.length > 0) {
                setRoiListCode(data?.CODE);
                const arr = getRoiList(data?.ROI_LIST);
                const position = arr[0]?.map(item => {
                    return [item[0] * width / 100, item[1] * height / 100];
                })
                setListPosition(position);
            }
        } catch (error) {
            Toast.open(t('settingCam.Unable_to_extract_recognition_areas'), 'danger')
        }
        // eslint-disable-next-line
    }

    const getPathStreaming = async () => {
        try {
            const res = await axiosClient.get(`camVideoQuality/get-cam-video-quality-for-config-roilist/?camera_code=${cameraCode}`)
            if (res && res.length > 0) {
                setPath(res[0].PATH);
            }
        } catch (error) {
            Toast.open(t('setting.No_images'), 'danger')
        }
    }

    useEffect(() => {
        setCanvas(canvasRef.current);
        const ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        const getData = async () => {
            if (canvasRef) {
                await getPathStreaming();
                await getConfigRoi();
            }
        }
        getData()
        // eslint-disable-next-line
    }, [canvasRef, reGetData, cameraCode, nameService])

    const drawSquareWithX = (ctx, x, y, size = 20) => {
        ctx.fillStyle = "#e8e8e846";
        ctx.fillRect(x - size / 2, y - size / 2, size, size);

        ctx.strokeStyle = "#00B335";
        ctx.lineWidth = 2;
        ctx.strokeRect(x - size / 2, y - size / 2, size, size);

        ctx.font = "14px Arial";
        ctx.fillStyle = "#00B335";
        ctx.fillText("X", x - 5, y + 5);
    };

    const drawCircleWithX = (ctx, x, y, radius) => {
        ctx.beginPath();
        ctx.arc(x, y, radius, 0, Math.PI * 2);
        ctx.fillStyle = "white";
        ctx.fill();
        ctx.stroke();

        const offset = radius / 2;
        ctx.beginPath();
        ctx.moveTo(x - offset, y - offset);
        ctx.lineTo(x + offset, y + offset);
        ctx.moveTo(x + offset, y - offset);
        ctx.lineTo(x - offset, y + offset);
        ctx.stroke();
    };

    const drawLine = (ctx, x, y) => {
        const size = 20;
        drawSquareWithX(ctx, x, y, size);
        drawCircleWithX(ctx, x + size / 2, y - size / 2, size / 4);
    };

    useEffect(() => {
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        // Xóa và vẽ lại toàn bộ canvas nếu không có điểm nào được kéo
        if (!pointEnter) {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            listPosition.forEach(([x, y]) => {
                drawLine(ctx, x, y);
            });
        } else {
            // Chỉ xóa vùng nhỏ quanh điểm đang di chuyển
            const [x, y] = pointEnter.split("&").map(Number);
            ctx.clearRect(x - 20, y - 20, 44, 44); // Xóa vùng nhỏ quanh điểm
            drawLine(ctx, x, y);
        }
    }, [canvas, listPosition, nameService, pointEnter])

    const handleCanvasClick = (event) => {
        setShowReload(true)
        const size = 20;
        const { offsetX: x, offsetY: y } = event.nativeEvent;
        const clickedDelete = listPosition.find(
            (point) => {
                const check = Math.abs((point[0] + size / 2) - x) < 4 && Math.abs((point[1] - size / 2) - y) < 4;
                return check;
            }
        );
        const clickedPoint = listPosition.find(
            (point) => {
                const check = Math.abs(point[0] - x) < 10 && Math.abs(point[1] - y) < 10;
                return check;
            }
        );
        if (clickedDelete) {
            setListPosition(prePos => {
                return prePos?.filter((item) => `${item[0]}&${item[1]}` !== `${clickedDelete[0]}&${clickedDelete[1]}`)
            })
        } else {
            if (draw) {
                if (clickedPoint) {
                    setPointEnter(`${clickedPoint[0]}&${clickedPoint[1]}`);
                } else {
                    const ctx = canvas.getContext("2d");
                    drawLine(ctx, x, y);
                    setListPosition(pre => [...pre, [x, y]]);
                }
            } else {
                if (clickedPoint) {
                    setPointEnter(`${clickedPoint[0]}&${clickedPoint[1]}`);
                }
            }
        }
    }

    // x1 y1, x2 , y2
    const handleUpdate = async () => {
        const convertPosition = listPosition?.map(posi => {
            return [posi[0] * 100 / width, posi[1] * 100 / height]
        })
        const dataPosition = JSON.stringify([convertPosition]);
        try {
            setIsLoading(true)
            await axiosClient.post('aiConfigRoiList/post-add-ai-config-roi-list/', {
                ai_service_code: codeService,
                camera_code: cameraCode,
                roi_list: {
                    data: dataPosition,
                }
            });
            Toast.open(`${t('setting.Setting')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t('stream.success')}`, 'success');
            setIsLoading(false);
            setReGetData(!reGetData)
        } catch (error) {
            // // console.log(error);
            setIsLoading(false);
            Toast.open(`${t('setting.Setting')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t('stream.error')}`, 'danger');
        }
    }

    const handleDelete = () => {
        setAlert(!alert);
    }

    const handleDraw = () => {
        setShowReload(true)
        setDraw(!draw);
    }

    const handleRestore = () => {
        setListPosition([]);
    }

    const reFreshConfig = async () => {
        try {
            await axiosClient.post('aiConfigRoiList/post-add-region-blocking/', {
                camera_code: cameraCode,
                region_blocking: {
                    data: JSON.stringify([]),
                }
            })
            Toast.open(`${t('setting.Reset_to_default')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} thành công`, 'success');
            setReGetData(!reGetData)
            setIsLoading(false);
            setAlert(false);
        } catch (error) {
            setIsLoading(false);
            Toast.open(`${t('setting.Reset_to_default')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} không thành công`, 'danger');
            setAlert(false);
        }
    }

    const handleCancel = () => {
        // onClose()
        setReGetData(!reGetData);
    }

    const handleMouseMove = (e) => {


        if (!pointEnter) return; // Không có điểm nào được chọn thì không làm gì
        setShowReload(true)
        const { offsetX: x, offsetY: y } = e.nativeEvent;
        setListPosition((prevPositions) => {
            return prevPositions.map(([X, Y]) => {
                if (`${X}&${Y}` === pointEnter) {
                    return [x, y]; // Cập nhật điểm đang kéo
                }
                return [X, Y]; // Giữ nguyên các điểm khác
            });
        });
        setPointEnter(`${x}&${y}`); // Cập nhật pointEnter theo vị trí mới
    };

    const handleMouseUp = () => {
        setPointEnter(null);
        setShowReload(true)
    }

    useLayoutEffect(() => {
        if (canvas) {
            // Fix size off canvas if screen hight quality
            const dpr = window.devicePixelRatio;
            const rect = canvas.getBoundingClientRect();
            canvas.width = rect.width * dpr;
            canvas.height = rect.height * dpr;
            const ctx = canvas.getContext("2d");
            ctx.scale(dpr, dpr);
            canvas.style.width = `${rect.width}px`;
            canvas.style.height = `${rect.height}px`;
            // Clear when remount or remove canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
    }, [canvas]);

    return (
        <>
            {alert && <Alert onClose={() => setAlert(!alert)} onOk={() => reFreshConfig(roiListCode)} title={` ${t('setting.Confirm_reset_to_default')}`} />}
            <div className={cx('list-config')}>
                <div className={cx('list-config-name')}>{
                    nameService?.toLowerCase() === 'cảnh báo cháy' ?
                        `${t('setting.Configure_the_area_without')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr?.toLocaleLowerCase() || nameService.toLowerCase()}` :
                        `${t('setting.Regional_configuration')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr?.toLocaleLowerCase() || nameService.toLowerCase()}`}
                </div>
                <div className={cx('draw-container')}>
                    <div className={cx('box-video')} style={{ width: `${width}px` }}>
                        {path ? (
                            <ReactPlayer
                                url={`${process.env.REACT_APP_BASE_URL}livestream${path}`}
                                height={`${height + 1}px`}
                            />
                        ) : (
                            <div style={{ width: '100%', height: `${height + 1}px` }}>
                                <p className={cx('no-image')}>{t('location.cameraIsOff')}</p>
                            </div>
                        )}
                        <canvas
                            ref={canvasRef}
                            className={cx('canvas-space')}
                            style={{
                                width: '100%',
                                height: `${height}px`,
                            }}
                            onMouseDown={handleCanvasClick}
                            onMouseMove={handleMouseMove}
                            onMouseUp={handleMouseUp}
                        />
                    </div>
                </div>
                <div className={cx('controller-draw')}>
                    <div className={cx('left-button')}>
                        <button className={cx('button-control')} onClick={() => setReGetData(!reGetData)}>
                            {t("setting.Refresh_image")}
                            <RefreshIcon />
                        </button>
                        <button className={cx('button-control', draw && 'active')} onClick={handleDraw}>
                            {t("setting.Drawing")}
                            <SquareIcon />
                        </button>
                    </div>
                    <div className={cx('right-button')}>
                        <button className={cx('button-control')} onClick={handleRestore}>
                            <RestoreIcon />
                        </button>
                    </div>
                    <div className={cx('right-button')}>
                        <button className={cx('button-control')} disabled>
                            Số vị trí: {listPosition?.length}
                        </button>
                    </div>
                </div>
            </div>
            {permissionChange && (
                <div className={cx("actions-setting")}>
                    <Button
                        onClick={handleDelete}
                        className={cx("btn-save")}
                        title={t('setting.Reset_to_default')}
                    />
                    {
                        showReload && <Button className={cx("btn-cancle")} title={t('cameraControl.Cancel')} onClick={handleCancel} />
                    }
                    <Button
                        onClick={handleUpdate}
                        className={cx("btn-save")}
                        title={t('settingCam.Save_settings')}
                    />
                </div>
            )}
        </>
    )
}

export default ConfigPositionCarPark;